import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { KYMW1318Component } from './kymw1318.component';
import { AppCommonsModule } from '../../../commons/app-commons.module';
import { WjCoreModule } from '@grapecity/wijmo.angular2.core';
import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { GetDeletePlanGoodsInfoService } from './api-services/get-delete-plan-goods-info';
import { DeletePlanGoodsInfoService } from './api-services/delete-plan-goods-info';

/**
 * 企画連絡承認画面 モジュール設定クラス
 *
 * @export KYMW1318Module
 * @class KYMW1318Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
    WjCoreModule,
    WjGridModule
  ],
  declarations: [
    KYMW1318Component
  ],
  providers: [
    GetDeletePlanGoodsInfoService,
    DeletePlanGoodsInfoService
  ]
})
export class KYMW1318Module {
}
